import * as React from "react";

export default class PaymentStatusErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className={"container"}><h4>There was an error showing you the payment status page. Your payment may have still processed.</h4></div>;
    }

    return this.props.children;
  }
}